import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormPanesSettingsUtil } from '@form/cer-form-panes/cer-form-panes.service';
import { CerFormView } from '@form/cer-form-view';

export class UserRouteForm extends CerFormAdapter {

  public override viewSetInit(viewSet: CerFormViewSet): void {
    viewSet.panes = CerFormPanesSettingsUtil.masterDetail('horizontal', true, 50);

    const view = UserRouteForm.userRouteViewGet();
    viewSet.viewAdd(view);
    const userView = UserRouteForm.userRouteViewViewGet();
    viewSet.viewAdd(userView, view);
  }

  public static userRouteViewGet(): CerFormView {
    const view = new CerFormView();
    view.viewMetadata = {
      name: 'menupunkt-brugere', dataApiName: 'AppUserRoute', text: 'Brugere', textSingular: 'Bruger',
      primaryKey: 'id', parentPrimaryKey: 'id', allowEdit: true, allowCreate: false, allowDelete: true, baseFields: ['id', 'history']
    };

    view.fieldMetadata =
      [
        { name: 'userId', text: 'Bruger', foreignKeyTableName: 'User', foreignKeyValue: 'shortName', allowEdit: false },
        { name: 'routeId', text: 'Menupunkt', foreignKeyTableName: "AppRoute", foreignKeyValue: 'url', allowEdit: false },
        { name: 'defaultView', text: 'Standard visning' }
      ];
    return view;
  }

  public static userRouteViewViewGet(): CerFormView {
    const view = new CerFormView();

    view.listSelectionMode = "checkboxMulti";
    view.viewMetadata = {
      name: 'bruger-visninger', dataApiName: 'AppUserRouteView', text: 'Visninger', textSingular: 'Visning',
      primaryKey: 'id', parentPrimaryKey: 'id', parentForeignKey: 'userRouteId', allowEdit: true, allowCreate: false, allowDelete: true, baseFields: ['id', 'history']
    };
    view.fieldMetadata =
      [
        { name: 'name', text: 'Visning' }
      ];
    return view;
  }
}
